<template>
<section>
    <div class="wrap">

        <div class="reservation_type_ul">
            <a :class="{ 'now' : (!visitChk) }" @click="changeTap(false)">예약내역</a>
            <a :class="{ 'now' : (visitChk) }" @click="changeTap(true)">방문완료</a>
        </div>
        
        <template v-if="bookingItems.length > 0">
            <ul class="reservation_type_list" v-if="!visitChk">
                <li 
                    v-for="booking in bookingItems" 
                    :key="`my-booking-item-${booking.id}`"
                    :class="{ 'reservation_wait' : (booking.status == BOOKING_STATUS.WAIT.id) }"
                    @click="$router.push(`/myBooking/${booking.id}`)"
                >
                    <span v-if="booking.alarm == 'Y'" class="new_alarm"></span>
                    <p class="type">
                        <span>{{bookingTitle(booking.status)}}</span>
                        
                        <a class="review_a">
                            내역확인
                            <i class="far fa-chevron-right"></i>
                        </a>
                        <!-- <router-link :to="`/myBooking/${booking.id}`" class="review_a">
                            내역확인
                            <img :src="$store.state.resource.imgIconNext2">
                        </router-link> -->

                        <!-- <router-link :to="`/myBooking/${booking.id}`" style="color:#666666">
                            내역확인
                            <img :src="$store.state.resource.imgIconNext">
                        </router-link> -->
                    </p>
                    <div class="my_reservation_info_box">
                        <div class="img">
                            <img v-if="booking.scAttUrl" :src="booking.scAttUrl"/>
                            <img v-else :src="$store.state.resource.imgIconUser"/>
                        </div>
                        <div class="info">
                            <dl>
                                <dt>{{booking.scName}} 컨설턴트</dt>
                                <dd>{{booking.shopName}} ({{booking.dealerName}})</dd>
                                <dd class="time">
                                    <span>{{bookingDate(booking.bookingDt)}}</span>
                                    <span>{{bookingTime(booking.bookingDt)}}</span>
                                </dd>
                            </dl>
                        </div>
                    </div>
                </li>
            </ul>

            <ul class="reservation_type_list" v-else>
                <li
                    v-for="booking in bookingItems"
                    :key="`my-booking-complete-item-${booking.id}`"
                    @click="$router.push(( (booking.reviewScId == null) ? `/ReviewScInput/${booking.id}` : `/myBookingReview/${booking.id}` ))"
                >

                    <div class="my_reservation_info_box">
                        <a class="review_a" v-if="booking.reviewScId == null">
                            후기작성
                            <i class="far fa-chevron-right"></i>
                        </a>
                        
                        <a class="review_a" v-if="booking.reviewScId > 0 ">
                            후기확인
                            <i class="far fa-chevron-right"></i>
                        </a>

                        <!-- <router-link :to="`/ReviewScInput/${booking.id}`" class="review_a" v-if="booking.reviewScId == null">
                            후기작성
                            <img :src="$store.state.resource.imgIconNext2">
                        </router-link>
                        
                        <router-link :to="`/myBookingReview/${booking.id}`" class="review_a" v-if="booking.reviewScId > 0 ">
                            후기확인
                            <img :src="$store.state.resource.imgIconNext2">
                        </router-link> -->


                        <div class="img">
                            <img v-if="booking.scAttUrl" :src="booking.scAttUrl"/>
                            <img v-else :src="$store.state.resource.imgIconUser"/>
                        </div>
                        <div class="info">
                            <dl>
                                <dt>{{booking.scName}} 컨설턴트</dt>
                                <dd>{{booking.shopName}} ({{booking.dealerName}})</dd>
                                <dd class="time">
                                    <span>{{bookingDate(booking.bookingDt)}}</span>
                                    <span>{{bookingTime(booking.bookingDt)}}</span>
                                </dd>
                            </dl>
                        </div>
                    </div>
                </li>
            </ul>
        </template>

        <none-data :title="noneDataTitle" v-else/>
    </div>
</section>
</template>

<script>
import { mapState } from 'vuex';
import { BookingFormatMixin } from '../../mixins/BookingFormatMixin';

export default {
    name:'BookingList',
    mixins:[BookingFormatMixin],
    async created() {
        this.$store.state.headerTitle = '나의 예약';
        this.$store.state.footer = true;
        await this.getBookings(this.visitChk);
        this.$store.commit('SHOW_ONLOAD');
    },
    data() {
        return {
            visitChk:false,
            bookingItems: [],
        }
    },
    computed: {
        ...mapState({
            auth: state => state.auth.item,
            BOOKING_STATUS: state => state.codeDictionary.items.BOOKING_STATUS,
        }),

        bookingStatusWaitConfirmed() {
            return [this.BOOKING_STATUS.WAIT.id, this.BOOKING_STATUS.CONFIRMED.id,this.BOOKING_STATUS.CHANGE.id].join(',');
        },

        bookingStatusVisit() {
            return [this.BOOKING_STATUS.VISIT.id,this.BOOKING_STATUS.CONTRACT.id].join(',');
        },

        noneDataTitle(){
            let title = ' 내역이 없습니다.';
            return (this.visitChk) ? '방문'+ title : '예약' + title ; 
        },
    },
    watch: {
    },

    methods: {

        changeTap(bool) {
            if(this.visitChk == bool) return;
            this.getBookings(bool);
        },

        getBookings(visitChk) {
            let statusList = (visitChk) ? this.bookingStatusVisit : this.bookingStatusWaitConfirmed;

            this.$store.dispatch('GET_BOOKING_LIST', {
                userId: this.auth.id,
                statusList,
            })
            .then( (data) => {
                this.visitChk = visitChk;
                this.bookingItems = data.content;
            });
        }
    },
}
</script>

<style lang="scss" scoped>

</style>